// extracted by mini-css-extract-plugin
export default {"container":"Popup_container__9tDmE","footer":"Popup_footer__a6AN3"};